import { useEffect, useState } from "react";
import "../style.css";
import { useNavigate, useParams } from "react-router-dom";
import {
  Form,
  message,
  Input,
  Button,
  Select,
  Checkbox,
  Switch,
  Popconfirm,
  Modal,
} from "antd";
import { Container, Row, Col } from "react-bootstrap";
import PageHeader from "../../../component/pageHeaders";
import { API } from "../../../config/API";
import { GET, POST, PUT } from "../../../utils/apirequest";
import api from "../../../config/axiosInstance";
import SCREENS from "../screens.json";

const EPAPER_AGENT_ROLE = 5;

function CreateUser() {
  const navigate = useNavigate();
  let { id } = useParams();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [error, setError] = useState({}) as any;
  const [selectedValues, setSelectedValues] = useState<string[]>([]);
  const [passwordValue, setPasswordValue] = useState("");

  useEffect(() => {
    if (id !== "create") {
      LoadDAta(id);
    }
  }, []);

  const LoadDAta = async (id: any) => {
    setLoading2(true);
    let url = API.USERS + `/${id}?populate=role`;
    try {
      const response: any = await GET(url, null, null);
      if (response?.id) {
        form.setFieldsValue({
          name: response?.username,
          email: response?.email,
          phone_number: response?.phone_number,
          role: response?.role?.id,
          code: response?.code,
        });

        // Load user_access and set selected modules
        // Load user_access and set selected modules
        if (response?.user_access) {
          let ua = String(response.user_access).trim();

          // Case 1: JSON formatted string (either array or single value quoted)
          if (
            (ua.startsWith("[") && ua.endsWith("]")) ||
            (ua.startsWith('"') && ua.endsWith('"'))
          ) {
            try {
              const parsed = JSON.parse(ua);
              if (Array.isArray(parsed)) {
                setSelectedValues(parsed.map(String));
              } else {
                // Single value that was JSON stringified
                setSelectedValues([String(parsed)]);
              }
            } catch (e) {
              console.log("JSON parse error, defaulting to string split", e);
              // Fallback if parse fails but it looks like JSON
              setSelectedValues(ua.split("|"));
            }
          }
          // Case 2: Pipe separated string (e.g. "17|0")
          else if (ua.includes("|")) {
            setSelectedValues(ua.split("|"));
          }
          // Case 3: Single value string (e.g. "17")
          else {
            setSelectedValues([ua]);
          }
        }
      }
      setLoading2(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading2(false);
    }
  };
  const handleCheckboxChange = (value: string) => {
    setSelectedValues((prevSelectedValues) => {
      let newSelectedValues;

      if (prevSelectedValues.includes(value)) {
        newSelectedValues = prevSelectedValues.filter((item) => item !== value);
      } else {
        newSelectedValues = [...prevSelectedValues, value];
      }
      const pipeString = newSelectedValues.join("|");
      console.log("Current selection array:", newSelectedValues);

      return newSelectedValues;
    });
  };

  const submitUser = async (body: any) => {
    const isCreate = id == "create";
    const url = isCreate ? API.CREATE_USER : API.PUT_UPDATE_USER + `${id}`;
    const METHOD = isCreate ? POST : PUT;
    try {
      const response: any = await METHOD(url, body);

      if (response?.error?.status === 409) {
        const code = response.error?.details?.code;
        const existing = response.error?.details?.existing;
        let msg =
          response.error?.message || "This email or phone is already in use.";
        if (code === "UP_USER_EXISTS" && existing?.username) {
          msg = `This email or phone is already used by user "${existing.username}".`;
        }
        if (code === "UP_USER_EMAIL_EXISTS") {
          setError({ email: "This email is already in use" });
        }
        if (code === "UP_USER_PHONE_EXISTS") {
          setError({ phone_number: "This phone number is already in use" });
        }
        message.error(msg);
        return;
      }
      if (response?.error) {
        message.error(
          response.error.message ||
            (isCreate
              ? "Could not create user. Please try again."
              : "Could not update user. Please try again.")
        );
        return;
      }
      if (response?.username) {
        navigate(-1);
        message.success(
          isCreate
            ? "User created successfully."
            : "User updated successfully."
        );
        return;
      }
      message.error(
        isCreate
          ? "Could not create user. Please try again."
          : "Could not update user. Please try again."
      );
    } catch (err: any) {
      const status = err?.status ?? err?.response?.status;
      const errBody =
        err?.data?.error ?? err?.error ?? err?.response?.data?.error;
      if (status === 409) {
        const code = errBody?.details?.code;
        const existing = errBody?.details?.existing;
        let msg = errBody?.message || "This email or phone is already in use.";
        if (code === "UP_USER_EXISTS" && existing?.username) {
          msg = `This email or phone is already used by user "${existing.username}".`;
        }
        if (code === "UP_USER_EMAIL_EXISTS") {
          setError({ email: "This email is already in use" });
        }
        if (code === "UP_USER_PHONE_EXISTS") {
          setError({ phone_number: "This phone number is already in use" });
        }
        message.error(msg);
      } else {
        message.error(
          errBody?.message ||
            (isCreate
              ? "Could not create user. Please try again."
              : "Could not update user. Please try again.")
        );
      }
    }
  };

  const onFinish = async (values: any) => {
    setLoading(true);
    try {
      const finalSelectedValues = [...selectedValues, "0"].filter(
        (value, index, self) => self.indexOf(value) === index
      );
      const normalizedEmail =
        typeof values?.email === "string"
          ? values.email.trim().toLowerCase()
          : "";
      const normalizedPhone = values?.phone_number
        ? String(values.phone_number).trim()
        : null;
      const roleId = parseInt(values?.role);

      const body: any = {
        username: values?.name,
        email: normalizedEmail,
        password: values?.password,
        role: values?.role,
        phone_number: normalizedPhone,
        screens: finalSelectedValues,
        user_access: finalSelectedValues.join("|"),
      };

      // Cross-table identity check at submit time — single source of truth.
      let identity: any = null;
      try {
        const params = new URLSearchParams();
        if (normalizedEmail) params.append("email", normalizedEmail);
        if (normalizedPhone) params.append("phone", normalizedPhone);
        const checkUrl = `${API.BASE_URL}${API.IDENTITY_CHECK}?${params.toString()}`;
        const res = await api.get(checkUrl);
        identity = res?.data || null;
      } catch (err) {
        console.error("identity check failed, continuing:", err);
      }

      const upHit = identity?.up || null;
      const epaperHit = identity?.epaper || null;
      const editingSameUser =
        id !== "create" && upHit && String(upHit.id) === String(id);

      // Case A: email/phone already belongs to another admin/agent account.
      if (upHit && !editingSameUser) {
        Modal.error({
          title: "Email or phone already in use",
          content: (
            <div>
              <p>
                This email or phone is already used by user{" "}
                <strong>{upHit.username}</strong>
                {upHit.code ? ` (${upHit.code})` : ""}.
              </p>
              <p style={{ marginTop: 8 }}>
                Please edit that user instead of creating a new one.
              </p>
            </div>
          ),
        });
        return;
      }

      // Case B: a subscriber exists with this email/phone.
      if (!upHit && epaperHit) {
        const linkedToAnotherAgent =
          epaperHit.agent_id && String(epaperHit.agent_id) !== "";

        if (roleId === EPAPER_AGENT_ROLE && id === "create") {
          // Role 5 creation mirrors the dedicated Agent form flow.
          if (linkedToAnotherAgent) {
            Modal.error({
              title: "This subscriber is already linked",
              content:
                "This subscriber is already linked to an existing agent. Please unlink the current agent before reusing this email or phone.",
            });
            return;
          }

          const proceed = await new Promise<boolean>((resolve) => {
            Modal.confirm({
              title: "Promote this subscriber to an agent?",
              content: (
                <div>
                  <p>
                    <strong>{epaperHit.full_name}</strong> is already registered
                    as a subscriber.
                  </p>
                  {epaperHit.email && <p>Email: {epaperHit.email}</p>}
                  {epaperHit.phone && <p>Phone: {epaperHit.phone}</p>}
                  <p style={{ marginTop: 12 }}>
                    Continuing will create an agent account and keep their
                    existing subscription attached. The subscriber's password
                    will be updated to match the new agent credentials.
                  </p>
                </div>
              ),
              okText: "Yes, promote to agent",
              cancelText: "Cancel",
              onOk: () => resolve(true),
              onCancel: () => resolve(false),
            });
          });
          if (!proceed) return;
        } else if (id === "create") {
          // Non-agent role creation: we still share the email/phone with a
          // subscriber. If that subscriber is already bound to another agent,
          // block — we must not overwrite another agent's credential.
          if (linkedToAnotherAgent) {
            Modal.error({
              title: "Email or phone is linked to another agent",
              content:
                "This contact is already registered as a subscriber and linked to another agent. Please use a different email or phone.",
            });
            return;
          }

          const proceed = await new Promise<boolean>((resolve) => {
            Modal.confirm({
              title: "This contact is already a subscriber",
              content: (
                <div>
                  <p>
                    <strong>{epaperHit.full_name}</strong> is already registered
                    as an e-paper subscriber.
                  </p>
                  {epaperHit.email && <p>Email: {epaperHit.email}</p>}
                  {epaperHit.phone && <p>Phone: {epaperHit.phone}</p>}
                  <p style={{ marginTop: 12 }}>
                    Continuing will create the admin user and update the
                    subscriber's password so both logins use the same
                    credentials.
                  </p>
                </div>
              ),
              okText: "Yes, create user",
              cancelText: "Cancel",
              onOk: () => resolve(true),
              onCancel: () => resolve(false),
            });
          });
          if (!proceed) return;
        }
      }

      await submitUser(body);
    } finally {
      setLoading(false);
    }
  };

  const checkUser = (event: any) => {
    if (event.target.value.length > 3) {
      const username = event.target.value;
      const isAlphanumeric = /^[a-zA-Z0-9]+$/.test(username);
      if (!isAlphanumeric) {
        setError({ name: "Name can only contain alphanumeric characters!" });
        return;
      }
      let body = {
        email: event.target.value,
        username: event.target.value,
      };
      api.post(API.GET_USERSEARCH, body).then((response) => {
        if (response.data.username.length) {
          setError({ name: "This Username already exists" });
        } else {
          setError("");
        }
      });
    }
  };

  // Inline email/phone checks are intentionally soft. Any cross-table
  // conflict (duplicate admin/agent, subscriber promotion, linked-to-other-agent)
  // is decided at submit via modals + backend 409 responses so there's a
  // single source of truth and stale onBlur state can't block the flow.
  const checkEmail = (_event: any) => {
    setError((prev: any) => {
      if (prev && typeof prev === "object" && prev.email) {
        const { email: _removed, ...rest } = prev;
        return rest;
      }
      return prev;
    });
  };

  const checkPhone = (_event: any) => {
    setError((prev: any) => {
      if (prev && typeof prev === "object" && prev.phone_number) {
        const { phone_number: _removed, ...rest } = prev;
        return rest;
      }
      return prev;
    });
  };

  const passwordRules = [
    { label: "Minimum 8 characters", test: (v: string) => v.length >= 8 },
    { label: "At least one lowercase letter", test: (v: string) => /[a-z]/.test(v) },
    { label: "At least one uppercase letter", test: (v: string) => /[A-Z]/.test(v) },
    { label: "At least one number", test: (v: string) => /\d/.test(v) },
    { label: "At least one special character", test: (v: string) => /[!@#$%^&*()_+[\]{};':"\\|,.<>?]/.test(v) },
  ];

  const allPasswordRulesPassed = passwordValue
    ? passwordRules.every((r) => r.test(passwordValue))
    : false;

  const validatePassword = (_: any, value: any) => {
    if (!value) return Promise.reject("Please input your password!");
    if (passwordRules.every((r) => r.test(value))) return Promise.resolve();
    return Promise.reject("");
  };

  let pipeString: any = "";

  const handleSelectAll = (checked: boolean) => {
    let newSelectedValues;

    if (checked) {
      // Select all modules
      newSelectedValues = SCREENS.map((item: any) => item.id);
    } else {
      // Deselect all
      newSelectedValues = [];
    }

    // Create pipe-separated string
    pipeString = newSelectedValues.join("|");

    // Console log the result
    // console.log('Select All:', checked ? 'CHECKED' : 'UNCHECKED');
    console.log("Current selection array:", newSelectedValues);
    // console.log('Pipe-separated string:', pipeString);
    // console.log('---');

    setSelectedValues(newSelectedValues);
  };
  const deleteData = async (id: any) => {
    setIsLoading(true);
    try {
      await api.delete(API.DELETE_USER + `${id}`);
      message.success("User deleted and all sessions revoked");
      setIsLoading(false);
      navigate(`/Auth/users?page=1&limit=10`);
    } catch (err) {
      console.log(err);
      message.error("Something went wrong...!");
      setIsLoading(false);
    }
  };

  return (
    <div>
      <PageHeader
        title={"Users"}
        loader={loading2}
        length={`Dashboard / Users / ${id === "create" ? "Create" : "Edit"} User`}
      >
        {id !== "create" && (
          <>
            <div style={{ width: 10 }} />
            <div>
              <Popconfirm
                placement="bottom"
                title={"Delete User"}
                description={"Are you sure you want to Delete"}
                okText="Yes"
                cancelText="No"
                onConfirm={() => deleteData(id)}
              >
                <Button loading={isLoading} danger>
                  Delete User
                </Button>
              </Popconfirm>
            </div>
          </>
        )}
      </PageHeader>
      <Form form={form} onFinish={onFinish} name="add-news" scrollToFirstError>
        <Container fluid>
          <Row style={{ padding: 10 }}>
            <Col sm={8} xs={12}>
              <Row>
                <Col sm="6" xs="12">
                  <label className="newsFormLabels">User Name</label>
                  <Form.Item
                    name="name"
                    rules={[
                      { required: true, message: "Please enter username" },
                    ]}
                    validateStatus={error["name"] ? "error" : ""}
                    help={error["name"]}
                  >
                    <Input size="large" onBlur={checkUser} />
                  </Form.Item>
                  <label className="newsFormLabels">Email</label>
                  <Form.Item
                    name="email"
                    rules={[
                      { required: true, message: "Please enter email" },
                      { type: "email", message: "Please enter a valid email" },
                    ]}
                    validateStatus={error["email"] ? "error" : ""}
                    help={error["email"]}
                  >
                    <Input size="large" onBlur={checkEmail} />
                  </Form.Item>
                  <label className="newsFormLabels">Phone number</label>
                  <Form.Item
                    name="phone_number"
                    validateStatus={error["phone_number"] ? "error" : ""}
                    help={error["phone_number"]}
                  >
                    <Input size="large" type="number" onBlur={checkPhone} />
                  </Form.Item>
                  {/* {id !== "create" && (
                    <>
                      <label className="newsFormLabels">Code</label>
                      <Form.Item name="code">
                        <Input size="large" disabled />
                      </Form.Item>
                    </>
                  )} */}
                </Col>
                <Col sm="6" xs="12">
                  <label className="newsFormLabels">Role</label>
                  <Form.Item
                    name="role"
                    rules={[{ required: true, message: "Please select a role" }]}
                  >
                    <Select placeholder="Select Role" size="large">
                      <Select.Option value={4}>Admin</Select.Option>
                      <Select.Option value={3}>Reporter</Select.Option>
                      <Select.Option value={6}>Epaper Admin</Select.Option>
                      <Select.Option value={5}>Epaper Agent</Select.Option>
                    </Select>
                  </Form.Item>
                  {id === "create" && (
                    <>
                      <label className="newsFormLabels">Password</label>
                      <Form.Item
                        name="password"
                        rules={[{ validator: validatePassword }]}
                        style={passwordValue && !allPasswordRulesPassed ? { marginBottom: 4 } : {}}
                        help={passwordValue && !allPasswordRulesPassed ? "" : undefined}
                      >
                        <Input.Password
                          size="large"
                          onChange={(e) => setPasswordValue(e.target.value)}
                        />
                      </Form.Item>
                      {passwordValue && !allPasswordRulesPassed && (
                        <div style={{ marginBottom: 12 }}>
                          {passwordRules.map((rule, i) => {
                            const passed = rule.test(passwordValue);
                            return (
                              <div
                                key={i}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 6,
                                  padding: "2px 0",
                                  fontSize: 13,
                                  color: passed ? "#52c41a" : "#999",
                                }}
                              >
                                <span style={{ fontSize: 14 }}>{passed ? "✓" : "✕"}</span>
                                {rule.label}
                              </div>
                            );
                          })}
                        </div>
                      )}
                      <label className="newsFormLabels">Confirm Password</label>
                      <Form.Item
                        name="confirm"
                        dependencies={["password"]}
                        rules={[
                          {
                            required: true,
                            message: "Please confirm your password!",
                          },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              const password = getFieldValue("password");
                              if (!value || password === value) {
                                return Promise.resolve();
                              }
                              return Promise.reject(
                                new Error("Passwords do not match")
                              );
                            },
                          }),
                        ]}
                        hasFeedback
                      >
                        <Input.Password size="large" />
                      </Form.Item>
                    </>
                  )}
                </Col>
              </Row>
            </Col>
            <Col sm={4} xs={12}>
              <div className="userfrom-box">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <div>
                    <label
                      className="newsFormLabels"
                      style={{ marginBottom: 0 }}
                    >
                      Manage Access
                    </label>
                  </div>
                  <div>
                    <Checkbox
                      onChange={(e) => handleSelectAll(e.target.checked)}
                      checked={
                        SCREENS.length > 0 &&
                        selectedValues.length === SCREENS.length
                      }
                      indeterminate={
                        selectedValues.length > 0 &&
                        selectedValues.length < SCREENS.length
                      }
                    >
                      Select All
                    </Checkbox>
                  </div>
                </div>

                <div className="user-access-list">
                  {SCREENS.length === 0 ? (
                    <div style={{ padding: 10 }}>No modules available</div>
                  ) : (
                    SCREENS?.map((item: any) => {
                      return (
                        <div className="userfrom-roles-item" key={item?.id}>
                          <Checkbox
                            checked={selectedValues.includes(item.id)}
                            onChange={() => handleCheckboxChange(item.id)}
                          >
                            {item?.module_name}
                          </Checkbox>
                        </div>
                      );
                    })
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <div style={{ height: "9vh" }} />
        <div className="FixedFooter">
          <Container fluid>
            <Row>
              <Col sm={9} xs={12}></Col>
              <Col sm={1} xs={6}>
                <Button
                  size="large"
                  type="text"
                  danger
                  block
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </Button>
              </Col>
              <Col sm={2} xs={6}>
                <Button
                  block
                  type="primary"
                  htmlType="submit"
                  size="large"
                  loading={loading}
                >
                  Submit
                </Button>
              </Col>
            </Row>
          </Container>
        </div>
      </Form>
    </div>
  );
}
export default CreateUser;
